import { Injectable } from '@angular/core';
import { Http, Headers, Response, RequestOptions, ResponseContentType } from '@angular/http';
import { Observable, Subscriber } from 'rxjs';
import 'rxjs/add/operator/map';
import { HttpClientService } from '../http-client/http-client.service';
import { Division } from '../../models/divisions/division';

@Injectable()
export class ReportService {

    constructor(
        private http: HttpClientService
    ) {

    }

    public getReportCard(divisionId) {
        const url = 'report/reportcard/' + divisionId;
        return this.http.get(url).map(response => {
            console.log('response*** ', response);
            var mediaType = 'application/pdf';
            var blob = new Blob([response.blob()], { type: mediaType });
            var filename = 'test.pdf';
            return blob
        }).catch(this.handleError);
    }

    public teacherSubjectSchedule(data: any): Observable<Blob> {
        const url = 'report/TeacherSubjectSchedule';
        const headers = new Headers({
            'Content-Type': 'application/json; charset=utf-8',
            'Accept': 'application/pdf'
        });
        const options = new RequestOptions({ headers: headers, responseType: ResponseContentType.Blob });
        return this.http.post(url, data, options)
            .map(response => response.blob())
            .catch(this.handleError);
    }

    public subjectSchedule(data: any): Observable<Blob> {
        const url = 'report/SubjectSchedule';
        const headers = new Headers({
            'Content-Type': 'application/json; charset=utf-8',
            'Accept': 'application/pdf'
        });
        const options = new RequestOptions({ headers: headers, responseType: ResponseContentType.Blob });
        return this.http.post(url, data, options)
            .map(response => response.blob())
            .catch(this.handleError);
    }

    public handleError(error: Response) {
        // console.error(error);
        return Observable.throw(error.json().error || 'Server error');
    }

}



// WEBPACK FOOTER //
// ./src/app/main/services/reports/report.service.ts